<template>
  <p
    v-if="useCookie('code').value"
    class="inline-flex items-center gap-2 rounded-full bg-green-500/10 px-4 py-2 text-green-500"
  >
    <Icon name="fa6-solid:ticket" class="-rotate-45" />
    <span class="text-sm">Cupom promocional aplicado</span>
  </p>
</template>
